import { Image, Text, View } from '@react-pdf/renderer';

import ei6 from '@assets/images/ei-6.jpg';
import { PublicEventDetailsResponse } from '@hubs101/booking-api-skd-client/lib/types';
import { multiTouchPointItems } from '@utils/constants';
import { useTranslation } from 'react-i18next';
import { globalStyles } from '../../styles';
import { styles } from './styles';

interface MultiTouchPointProps {
  event: PublicEventDetailsResponse;
}

const MultiTouchPoint = ({ event }: MultiTouchPointProps) => {
  const { t } = useTranslation();

  return (
    <View style={{ ...globalStyles.body, paddingTop: 20 }}>
      <Text
        style={{
          ...globalStyles.mediumTitle,
          color: event?.design?.themeColor,
          marginBottom: 0,
          marginTop: 0,
        }}
      >
        {t('multi-touch-point')}
      </Text>

      <View
        style={{
          ...globalStyles.lineBar,
          borderColor: event?.design?.themeColor ?? 'black',
          marginTop: 0,
        }}
      />

      <Text style={{ ...styles.title, paddingBottom: 0 }}>
        {t('multi-touch-point-networking-experience')}
      </Text>

      <View style={styles.multiTouchPointWrapper}>
        {multiTouchPointItems?.map((item, index) => {
          const isEven = index % 2 === 0;

          return (
            <View
              style={{
                ...styles.multiTouchPointItem,
                flexDirection: isEven ? 'row' : 'row-reverse',
              }}
              wrap={false}
              key={item.title}
            >
              <View style={styles.textWrapper}>
                <Text
                  style={{
                    ...styles.itemTitle,
                    color: event?.design?.themeColor ?? 'black',
                  }}
                >
                  {t(item.title)}
                </Text>
                <Text style={styles.itemSubtitle}>{t(item.subtitle)}</Text>
              </View>
              <View style={styles.imageWrapper}>
                <Image
                  style={{
                    ...styles.image,
                    borderTopRightRadius: isEven ? '8px' : 0,
                    borderBottomRightRadius: isEven ? '8px' : 0,
                    borderTopLeftRadius: !isEven ? '8px' : 0,
                    borderBottomLeftRadius: !isEven ? '8px' : 0,
                  }}
                  src={item.imageUrl}
                />
              </View>
            </View>
          );
        })}
      </View>
    </View>
  );
};

export default MultiTouchPoint;
